
export default class ComingSoon {}
